const zh = {
    enter_code: "会话 ID",
    connect: "连接",
    check_your_internet_connection: "检查您的 Internet 连接。",
    network_error: "网络错误",
    server_error: "服务器错误",
    check_server_connection: "内部服务器错误",
    downtime: "停机时间",
    server_is_currently_facing_downtime: "服务器目前面临停机",
    show_what_you_see: "展示你所看到的",
    by_joining_i_confirm_that_i_have_read_and_understand_the: "我确认我已阅读并同意隐私政策。",
    privacy_policy: "隐私政策",
    invalid_code: "无效的会话 ID",
    code_should_be_of_nine_digits: "会话 ID 应为 9 位数字",
    blitzz: "闪电战",
    please_enter_your_name: "请输入你的名字",
    maximum_value_is_30: "名称应少于 30 个字符。",
    please_enter_meeting_id: "请输入您的会话 ID",
    please_try_again: "请再试一次。",
    no_one_is_sharing_video: "没有人分享视频。",
    retry: "重试",
    reconnect: "重新连接",
    left_the_conversation: "离开了对话",
    enabled_the_audio: "启用音频",
    disabled_the_audio: "禁用音频",
    enabled_the_video: "启用视频",
    disabled_the_video: "禁用视频",
    failed_to_join_room: "加入房间失败",
    alert: "警报",
    override_video_sharing_message: "您想结束当前的屏幕共享并开始共享您的视频吗？",
    override_screen_sharing_message: "您想结束当前的屏幕共享并开始共享您的屏幕吗？",
    override_video_sharing_with_screen_capturing_message: "您想结束当前视频并开始共享您的屏幕吗？",
    override_screen_sharing_with_video_sharing_message: "您想结束当前的屏幕共享并开始共享您的视频吗？",
    yes: "是的",
    cancel: "取消",
    joined_the_call: "加入通话",
    waiting_for_other_members_to_join_the_call: "等待其他成员加入通话",
    warning: "警告",
    camera_permission_disabled: "无法访问相机。",
    microphone_permission_disabled: "无法访问麦克风。",
    location_permission_disabled: "无法访问位置。",
    storage_permission_disabled: "无法访问存储",
    permission_error_message_camera: "请从设备设置启用相机。",
    permission_error_message_microphone: "请从设备设置启用麦克风。",
    permission_location_error_message: "请从设备设置中启用位置信息。",
    permission_storage_error_message: "请从设备设置启用存储。",
    give_permission: "给予许可",
    please_wait_for_five_seconds_to_take_screenshot: "请等待 5 秒钟再拍摄一张照片",
    please_wait_for: "请稍等",
    seconds_to_take_screen_shot: "秒拍另一张照片。",
    second_to_take_screen_shot: "第二张照片。",
    invalid_information_received_from_server: "从服务器收到的信息无效。",
    unable_to_share_screen_as_no_one_else_has_joined_the_conversation_yet: "无法分享视频，因为还没有其他人加入对话",
    successfully_uploaded: "上传成功",
    disconnected: "断开连接",
    call_ended_as_no_one_else_had_joined_the_call: "由于没有其他人加入而断开连接。",
    application_update_required: "需要应用程序更新",
    update_required_message: "看起来您使用的是旧版本的应用程序，请从应用商店更新。",
    update: "更新",
    image_marking_started: "图像标记开始",
    image_marking_stopped: "图像标记停止",
    settings: "设置",
    camera_permission_rationale: "我们需要访问您的相机。请给予相机许可",
    microphone_permission_rationale: "我们需要使用您的麦克风。请给予麦克风许可",
    location_permission_rationale: "我们需要访问您的位置。请给予位置许可",
    storage_permission_rationale: "我们需要访问您的存储空间。请给予存储许可",
    call_between_two_customers: "代理尚未加入，请稍后重试。",
    media_projection_permission_needed_for_screen_sharing: "屏幕共享需要媒体投影权限。",
    poor_network_connection: "警告！网络连接不良",
    you_are_the_only_person_in_the_call: "你是通话中唯一的人",
    image_has_been_captured_and_started_uploading: "图像已被捕获并开始上传",
    version: "版本",
    please_enter_the_code_provided_to_you: "请输入提供给您的代码。",
    start_screen_share: "共享屏幕",
    stop_screen_share: "停止分享",
    flip_camera: "翻转相机",
    take_photo: "拍照",
    flash_off: "闪光灯关",
    flash_on: "闪光灯开",
    start_markup: "开始标记",
    stop_markup: "停止标记",
    speaker_off: "扬声器关闭",
    speaker_on: "扬声器开启",
    more: "更多的",
    close: "关闭",
    video_off: "视频关闭",
    video_on: "视频开启",
    start_video: "开始视频",
    stop_video: "停止视频",
    disconnect: "断开",
    mute: "沉默的",
    muted: "取消静音",
    powered_by_blitzz: "由闪电提供技术支持",
    connecting_your_call: "连接的。等待其他参与者。",
    connected: "连接的",
    pin_is_of_nine_digit: "引脚应为 9 位",
    preparing_image_for_markup: "正在为标记准备图像…",
    clear_markup_confirmation: "清除所有用户的图像标记？",
    clear_markup: "清除标记",
    clear: "清除",
    close_markup: "关闭标记",
    end_markup_confirmation: "您确定要关闭标记吗？",
    end: "结尾",
    agent_has_ended_markup_cannot_continue_without_agent: "代理已结束标记。没有代理无法继续标记",
    joining_image_markup: "正在加载用于标记的图像...",
    cleared_markup: "清除所有用户的图像标记。",
    capturing_photo: "正在拍摄照片…",
    uploading: "上传",
    image: "图片",
    image_ready_for_markup: "图像准备好标记。",
    override_video: "这将停止其他人的视频。你要继续吗？",
    override_screen_share: "这将停止其他人的屏幕共享。你要继续吗？",
    started_screen_share: "启动屏幕共享。",
    stopped_screen_share: "停止屏幕共享。",
    clear_all: "清除所有",
    start_new_call_popup: "使用 CODE 开始新通话",
    group_call_limit_reached: "已达到组呼限制",
    contact_admin_to_increase_participant_limit: "请等待任何其他参与者断开连接，然后重试。",
    call_is_being_connected: "正在接通电话，请稍后再试。",
    show_recording_for_training_purpose: "本次会议正在录制中。",
    you_are_sharing_the_screen: "您正在共享屏幕",
    location_colon: "地点：",
    date_colon: "日期：",
    image_for_markup_has_been_downloaded: "标记图像已下载",
    dismiss: "解雇",
    google_play_service_is_not_up_to_date: "谷歌播放服务未更新",
    rec: "记录",
    you_are_offline: "您处于离线状态。",
    markup: "标记",
    exit: "出口",
    video_unsupported: "视频不受支持",
    please_open_this_link_in_safari: "请在 Safari 中打开此链接。",
    you_are_not_able_to_see_this_video: "您无法观看此视频。",
    only_number_Allowed: "只允许使用数字。",
    permission_warning: "权限警告",
    unable_to_join_call_please_try_after_sometime: "无法加入通话。请稍后再试",
    share_live_video: "分享您的直播视频？",
    share_your_screen: "共享您的屏幕？",
    unable_access_flash: "无法访问闪光灯。",
    camera_unavailable_try_again: "相机不可用，请重试。",
    unable_download_image_tomarkup: "无法从服务器下载图像，请重试。",
    try_again: "再试一次",
    markup_screen_appear_shortly: "标记屏幕将很快出现...",
    confirm: "确认",
    start: "开始",
    could_not_find_endpoint: "找不到服务器端点。",
    please_wait: "请稍等...",
    done: "完毕",
    ok: "好的",
    please_try_again_with_valid_agent_id: "请使用有效的代理 ID 重试。",
    meeting_code_not_associated_with_agent: "会话 ID 与此代理 ID 无关。",
    powered_by: "供电",
    failure: "失败",
    code: "会话 ID",
    start_new_call_question: "开始新的通话？",
    stop_sharing: "停止分享",
    reconnecting_call: "正在重新连接呼叫...",
    unable_to_access_mircrophone_or_camera: "无法访问您的麦克风或摄像头。",
    be_sure_to_allow_access_in_browser: "请务必在浏览器设置中允许访问。",
    make_sure_you_have_microphone_camera_attached: "确保连接了摄像头或麦克风。",
    location_blocked_by_user: "位置被用户屏蔽",
    user_has_joined_the_call: "用户已加入通话",
    are_you_sure_you_want_to_close_window: "您确定要关闭此窗口吗？",
    reset_guide: "重置指南",
    open_in_google_maps: "在 Google 地图中打开",
    location_image_upload_failed: "位置图片上传失败",
    uploading_image: "上传图片",
    upload_failed: "上传失败",
    markup_is_in_progress: "标记正在进行中...",
    select_language: "选择语言",
    checking_for_extension: "正在检查扩展名...",
    start_incognito_mode_from_blitzz_screen_share_ext: "要在隐身模式下启动屏幕共享，您需要从 Blitzz - 浏览器的屏幕共享扩展程序启动隐身模式。",
    click_on: "点击",
    customize_and_control_menu: "自定义和控制菜单",
    more_tools: "更多工具",
    extensions: "扩展",
    click_on_detail: "单击详细信息（闪电战）",
    allow_in_incognito: "允许在隐身。",
    screen_share: "屏幕共享",
    stop_share: "停止分享",
    save: "节省",
    cancel_initcap: "取消",
    yes_initcap: "是的",
    message_title: "信息",
    device_not_compatible: "抱歉，此设备不兼容。",
    please_download_our_app: "请下载我们的应用程序以继续。",
    download_app: "下载应用程序",
    this_browser_is_not_supported: "目前不支持此浏览器。",
    open_in_chrome_or_install_mobile_app: "请将此链接复制并粘贴到最新版本的 Google Chrome 中或安装我们的移动应用程序，然后重试。",
    open_in_safari_or_install_mobile_app: "请复制并粘贴此链接到最新版本的 Safari 浏览器或安装我们的移动应用程序，然后重试。",
    open_in_chrome_and_try_again: "请在最新版本的 Google Chrome 中打开此链接，然后重试。",
    okay_initcap: "好的",
    would_you_like_to_install_app_or_continue_browser: "您想安装我们的应用程序以加入会议还是使用浏览器继续？",
    continue_initcap: "继续",
    webview_limited_support_message: "为了获得最佳体验，请使用 Chrome 浏览器或您的默认浏览器打开。",
    continue_anyway: "继续",
    open_in_browser: "在浏览器中打开",
    link_copied_open_in_browser: "链接已复制！如果浏览器没有打开，请将链接粘贴到Chrome浏览器中。",
    add_blitzz_extension_to_screen_share: "将 Blitzz 扩展程序添加到屏幕共享",
    add_to_chrome_and_confirm: "'添加到 Chrome 并确认'",
    add_extension: "添加扩展",
    permission_error_message_camera_browser: "请从浏览器设置启用相机。",
    camera_not_found: "未找到相机",
    enable_camera_and_reconnect_call: "您需要启用相机，重新加载页面并重新连接呼叫。",
    permission_error_message_microphone_browser: "请从浏览器设置启用麦克风。",
    microphone_not_found: "未找到麦克风",
    enable_microphone_and_reconnect_call: "您需要启用麦克风，重新加载页面并重新连接通话。",
    download_failed: "下载失败",
    continue_markup: "继续标记",
    save_and_exit: "保存并退出标记",
    exit_markup: "退出标记",
    you_are_recording_the_conversation: "您现在正在录制对话。",
    make_sure_participant_know_they_are_being_recorded: "确保参与者知道他们正在被录音。",
    you_can_download_recordings_later: "之后您可以下载录制的文件。",
    share_without_joining_session_lanuch_showme_enter_code: "不加入 ShowMe 会话就无法共享屏幕。请启动 Blitzz 的 ShowMe，并输入提供给您的会话 ID。",
    call_limit_reach_contact_Admin_to_increase_limit: "已达到组呼限制。请联系您的管理员以增加参与者限制或等待成员离开会话。",
    other_user_trying_share_screen_Video: "其他用户正在尝试共享屏幕或视频",
    call_has_ended: "通话已结束",
    would_you_like_to_save_image: "您要保存图像吗？",
    audio_unsupported: "不支持音频",
    please_install_our_app_to_continue: "请安装我们的应用程序以继续。",
    unable_to_play_remote_audio: "无法播放远程音频。",
    unable_to_playback_audio: "无法播放音频。",
    unable_to_play_video: "无法播放视频。",
    unable_to_playback_video: "无法播放视频。",
    okay_cap: "好的",
    pre_call_test: "通话前测试",
    language: "语",
    reset: "重启",
    zoom_in: "放大",
    zoom_out: "缩小",
    headset: "耳机",
    bluetooth: "蓝牙",
    live_pointer_enabled_message: "开始实时指针。您可以通过拖动来移动指针。",
    speaker: "扬声器",
    live_pointer_disabled_message: "停止的实时指针",
    step_one: "第1步",
    step_two: "第2步",
    pointer: "指针",
    network_quality: "网络质量",
    participant: "参与者",
    you: "（你）",
    reconnecting: "重新连接",
    very_bad: "很坏",
    bad: "坏的",
    poor: "贫穷的",
    good: "好的",
    excellent: "优秀",
    loc: "位置",
    expand: "扩张",
    collapse: "坍塌",
    network: "网络",
    ocr_inprogress: "OCR 正在进行中...",
    select_area_extract_text: "选择要提取文本的区域",
    text_copied: "复制的文本",
    extract_text_from_image: "从图像中提取文本...",
    not_extract_text_from_image: "无法从图像中提取文本。",
    try_again_clear_image_or_reselect_region: "请使用清晰的图像重试，或重新选择您的提取区域。",
    error: "错误",
    occured_while_receiving_doc: "接收文件时发生。",
    return_to_video: "返回视频",
    save_entire_image: "保存整个",
    save_cropped_image: "保存裁剪",
    text_copied_to_clipboard: "点击复制",
    extract_text: "提取文本",
    stop_pointer: "停止指针",
    reference: "参考",
    do_not_rotate_the_phone_live_pointer_message: "为了获得更好的观看体验，请不要在启用实时指针时旋转设备。",
    got_it_btn: "知道了！",
    email: "电子邮件",
    mobile_number: "手机号码",
    speed_test: "速度测试",
    duration: "期间",
    preparing_image_for_OCR: "为文本处理准备图像…",
    agent_extract_text_from_image: "请稍候，代理正在从捕获的图像中提取文本。",
    unable_download_image_to_ocr: "无法下载图像进行处理，请重试。",
    selected_area_is_small: "选择的区域太小，",
    please_select_large_area: "请选择大面积的图像。",
    zoom_level: "缩放级别",
    do_not_rotate_the_phone_markup_message: "为了获得更好的观看体验，请不要在启用标记时旋转设备。",
    uploaded_images: "图片上传",
    upload_completed: "上传完成",
    capturing: "正在捕捉...",
    network_quality_not_available: "网络质量不可用",
    not_able_to_see_your_stream: "将无法看到您的信息流",
    device_not_supported: "设备不受支持。",
    video_settings_need_to_be_configured_by_admin_web: "您的管理员需要配置视频设置以支持此设备。请联系您的公司管理员或发送电子邮件",
    contact: "接触",
    video_paused_by_agent: "视频被代理暂停",
    screenshare_paused_by_agent: "屏幕共享被代理暂停",
    not_shared: "未共享",
    permission_error_message_location_browser: "请从浏览器设置启用位置。",
    network_type: "网络类型",
    update_your_browser_to_share_your_screen: "将您的浏览器更新到最新版本以共享您的屏幕",
    image_thumb_caption: "图片",
    saved_images: "保存的图像",
    try_these_option_to_have_better_experience: "尝试这些选项之一以获得更好的体验。",
    some_features_are_not_supported_in_this_browser: "此浏览器不支持某些功能。",
    unsupported_browser: "不支持的浏览器",
    permission_message_for_screenshare: "访问屏幕区域的权限被拒绝，或者您当前的浏览器实例没有访问屏幕共享的权限。",
    go_to_system_preferences: "转到系统偏好设置",
    security_privacy: "安全与隐私",
    select_privacy_tab: "选择隐私选项卡",
    screen_recording: "屏幕录制",
    select_google_chrome: "选择谷歌浏览器",
    use_chrome_to_share_your_screen: "使用 Chrome 或 Firefox 浏览器共享您的屏幕",
    agree: "同意",
    decline: "衰退",
    there_was_an_error_trying_to_share_your_video: "尝试分享您的视频时出错。",
    please_stop_video_and_start_video_again_to_resume: "请停止视频并重新开始视频以恢复。",
    click_the_padlock: "点击挂锁",
    to_the_left_of_a_web_page_address: "地址栏左侧。",
    clear_blocked_permission_for_share_the_screen: "清除权限部分下的所有被阻止的屏幕共享权限。",
    select_your_browser: "选择您的浏览器",
    tips_colon: "提示：",
    your_internet_connection_is_unstable: "您的互联网连接不稳定",
    participants_connection_unstable: "参与者<participantNum>的网络连接不稳定",
    draw: "画",
    rect: "矩形",
    text: "文本",
    enter_text_here: "在此输入文字",
    showme_app_found: "找到 ShowMe 应用程序",
    use_showme_app: "使用 ShowMe 应用程序",
    showme_app_for_guest_user:
        "我们在此设备上检测到一个针对访客用户的轻量级 ShowMe 应用程序。此应用程序没有高级功能。请卸载应用程序，然后重新加入以继续使用浏览器。",
    participants_title: "参与者",
    bookmarks_title: "书签",
    search_or_add_new_bookmark: "搜索或添加新书签",
    create_new_bookmark: "创建新书签",
    press_enter_or_click_on_create_new_bookmark: "按 Enter 或单击“创建新书签”以添加新书签",
    tap_retry_to_load: "点击重试加载",
    bookmark_saved_with_image: "与图像一起保存的书签。",
    bookmark_saved: "书签已保存。",
    failed_to_bookmark_please_try_again: "无法添加书签。请再试一次。",
    try_our_mobile_app: "在应用程序中打开",
    still_facing_issue_connect_mobile_app: "如果您仍然遇到问题，请使用我们的移动应用程序进行连接。",
    open_in_app: "在应用程序中打开",
    enable_microphone_from_browser_settings: "从浏览器设置启用麦克风。",
    enable_camera_from_browser_settings: "从浏览器设置启用相机。",
    unable_to_access_microphone: "无法访问麦克风",
    special_characters_are_not_allowed: "不允许有特殊字符。",
    home_screen: "主屏幕",
    bookmark_added: "添加了书签。",
    privacy_policy_popup_text_description:
        "我理解并同意自愿使用我的相机分享我周围的景色以解决我遇到的技术问题。我了解不会进行或存储任何录音。我可以随时关闭共享功能。我不会将相机对准我不想分享图像的区域、个人或物品。我还确认我已阅读并同意隐私政策。",
    allow_access_to_location: "允许访问位置",
    allow_access_to_location_description: "在下一个弹出窗口中允许访问您的位置以验证您的位置。",
    ok_i_understand: "好，我懂了",
    allow_microphone_access: "允许麦克风访问",
    allow_microphone_access_description: "允许访问您的麦克风，以便其他参与者可以听到您的声音。",
    allow_camera_access: "允许访问相机",
    allow_camera_access_description: "在下一个弹出窗口中允许访问您的相机。",
    allow_bluetooth_access: "允许蓝牙访问",
    allow_bluetooth_access_description: "允许访问您的蓝牙以在音频源之间切换。",
    permission_error_message_for_camera:
        "权限错误：我们无权访问您的相机。转到设置并启用相机权限。这将断开正在进行的呼叫。您可以通过再次启动应用程序来重新连接。",
    permission_error_message_for_microphone:
        "权限错误：我们无权使用您的麦克风。转到设置并启用麦克风权限。这将断开正在进行的呼叫。您可以通过再次启动应用程序来重新连接。",
    permission_error_message_for_location:
        "权限错误：我们无权访问您的位置。转到设置并启用位置权限。这将断开正在进行的呼叫。您可以通过再次启动应用程序来重新连接。",
    enable_microphone: "启用麦克风",
    enable_camera: "启用相机",
    enable_location: "启用位置",
    enable_bluetooth: "启用蓝牙",
    audio_issue_ios: "音频问题？",
    toggle_mic_icon_guest_msg: "切换上面的红色麦克风/摄像头图标，或使用电话中的音频。 (PSTN)",
    toggle_mic_icon_agent_msg: "要求 iOS 用户切换上面的红色麦克风/摄像头图标，或使用电话中的音频。 (PSTN)",
    audio_ios_msg_read_more: "阅读更多",
    error_occured_in_processing_the_request: "处理请求时出错。请再试一次。",
    markup_ocr_upload_timeout: "比平时花的时间更长。",
    markup_cancelled: "标记已取消",
    ocr_cancelled: "取消提取文本",
    click_here: "点击这里",
    to_return_to_video_and_try_again: "返回视频并重试。",
    markup_exit: "停止标记",
    ocr_exit: "停止提取文本",
    camera: "相机",
    camera_blocked: "摄像头被阻挡",
    microphone: "麦克风",
    microphone_blocked: "麦克风被阻止",
    speakers: "扬声器",
    speakers_blocked: "扬声器被阻止",
    grant_permission: "授予权限",
    play_test_sound: "播放测试声音",
    call_settings: "通话设置",
    allow_access_to_camera: "允许访问您的相机。",
    allow_access_to_mic: "允许访问您的麦克风。",
    default_label: "默认",
    do_not_rotate_the_phone_OCR_message: "为了获得更好的观看体验，请不要在启用提取文本时旋转设备。",
    test_connection: "测试连接",
    browser_not_supported: "浏览器不支持",
    your_browser_not_support_video: "您的浏览器不支持视频通话。",
    open_link_in_google_samsung_browser: "请将此链接复制并粘贴到最新版本的 Google Chrome 或三星 Internet 浏览器中。",
    open_link_in_safari_browser: "请复制此链接并将其粘贴到最新版本的 Safari 浏览器中。",
    copy_link: "复制链接",
    copy_code: "复制代码",
    guest_url_copy: "访客 URL 已复制到剪贴板。",
    session_code_copy: "会话 ID 已复制到剪贴板。",
    meeting_code_lable: "会议代码",
    add_participant_lable: "添加参与者",
    send_this_link_to_guest: "将此链接发送给客人",
    send_an_email: "发送电子邮件",
    or_label: "或者",
    remote_mic_cam_error: "远程参与者的麦克风/摄像头有错误。",
    device_not_supported_or_permi_block: "他们的设备不受支持，或者他们的权限被阻止。",
    remote_participant: "远程参与者",
    microphone_unmuted: "麦克风取消静音",
    microphone_muted: "麦克风静音",
    camera_on: "相机开启",
    camera_off: "相机关闭",
    earpiece: "听筒",
    error_label: "错误",
    cannot_start_video: "无法开始视频",
    failed_to_start_video_camera: "无法启动摄像机。",
    please_select_another_camera_from_call_settings: "请从通话设置中选择另一个摄像机。",
    please_select_another_video_camera: "请选择其他摄像机。",
    chat: "聊天",
    chat_info: "通话中的每个人都可以看到聊天消息。根据设计，当您断开连接时，聊天记录将永久消失。",
    chat_input_placeholder: "输入消息",
    participant_connected: "<participantCount>参与者已连接",
    click_to_share_invite: "点击分享邀请",
    remote_flashlight_not_supported_on_guest_device_or_not_ready: "来宾设备不支持远程手电筒或未准备好",
    pin_a_video_tile_above_to_use_this_feature: "在上方固定视频图块以使用此功能",
    pin_video_for_all_participants: "为所有参与者固定视频",
    return_to_gallery_view: "返回画廊视图",
    override_own_screen_share: "您的屏幕共享将停止。你要继续吗？",
    override_own_video: "您的视频将被停止。你要继续吗？",
    you_have_started_the_video: "您已开始播放视频",
    back_lable: "背部",
    front_lable: "正面",
    blur: "模糊",
    mask_lable: "面具",
    view_text: "看法",
    stop_label: "停止",
    recording_stopped: "录音停止",
    error_recording_please_try_again: "录制时出错，请重试",
    error_recording_wait_or_disconnect_call: "错误记录。请等待主持人停止录制，否则您可能会断开连接并稍后重新加入。",
    wait_for_recording: "正在开始录制，请稍候...",
    max_participant_limit_for_recording: "最大限度。录制时达到参与者限制。请等待主持人停止录制，否则您可能会断开连接并稍后重新加入。",
    start_recording: "已开始录制。",
    stop_recording: "录制已停止。",
    arrow: "箭",
    error_recording_all_participants: "记录所有参与者时出错。",
    please_stop_and_restart_recording: "请停止并重新开始录制。",
    some_participants_will_not_be_recorded: "部分参与者将不会被记录。",
    participant_limit_reached: "已达到参与者限制。",
    your_account_has_4_participant_limit_while_recording: "您的帐户在录制时有 4 名参与者的限制。",
    disconnect_call: "断开呼叫",
    record_title: "记录",
    stop_recording_btn: "停止录音",
    back_to: "回到",
    remind_me_later: "稍后提醒我",
    skip_this_update: "跳过此更新",
    cam_per_denied_msg: "您的一位参与者可能在其设备上阻止了相机访问。要指导他们，请查看",
    mic_per_denied_msg: "您的一位参与者可能在其设备上阻止了麦克风访问。要指导他们，请查看",
    cam_mic_per_denied_msg: "您的一位参与者可能已阻止其设备上的摄像头和麦克风访问。要指导他们，请查看",
    your_camera_block: "你的摄像头被屏蔽了",
    your_microphone_block: "你的麦克风被屏蔽了",
    your_location_block: "您的位置已被屏蔽",
    we_cannot_access_your_camera: "我们无法访问您的相机。",
    we_cannot_access_your_microphone: "我们无法访问您的麦克风。",
    we_cannot_access_your_location: "我们无法访问您的位置。",
    go_to_browser_settings: "要授予访问权限，请转到浏览器设置，然后单击此处重新加载页面。",
    still_facing_issue: "仍然面临问题？",
    try_the: "试试",
    mobile_app: "移动应用",
    view_help_article: "查看帮助文章",
    enable_or_attach_camera_and_reconnect_call: "您需要启用或连接摄像头，重新加载页面并重新连接呼叫。",
    enable_or_attach_microphone_and_reconnect_call: "您需要启用或连接麦克风，重新加载页面并重新连接呼叫。",
    per_denied_common_msg: "有关重置浏览器权限的快速提示。",
    start_rec_label: "开始记录。",
    stop_rec_label: "停止记录。",
    start_recording_tooltip_label: "开始录音",
    cam_per_denied_title: "远程参与者的摄像头被阻止",
    mic_per_denied_title: "远程参与者麦克风被阻止",
    cam_mic_per_denied_title: "远程参与者的摄像头和麦克风被阻止",
    these_instructions: "这些说明",
    click_here_label: "点击这里",
    from_participant: "来自参与者",
    download_key: "下载",
    download_not_supported_text: "您的设备不支持下载。",
    undo: "撤消",
    redo: "重做",
    fill: "填",
    Whisper_on: "耳语",
    Whisper_off: "悄悄话",
    enable_whisper_tooltip_label: "启用耳语与主持人通话",
    host_can_hear_you_now: "主持人现在可以听到您的声音",
    mediate_lable: "调解",
    join_call_as_participant: "作为参与者加入通话",
    observer_lable: "观察员",
    silent_observer_connect_alert_popup: "已作为观察员连接。您的麦克风和摄像头已静音。",
    click_mediate_if_you_would_like_to_join_as_a_participant: "如果您想作为参与者加入，请单击“调解”。",
    Silent_observer_lable: "沉默的观察者",
    invite_participant_tooltip_lable: "Silent Observer 的麦克风和摄像头将被静音，访客参与者将看不到它们。",
    send_link_silent_observer: "将此链接发送给沉默的观察者。",
    join_as_mediator_title: "加入调解员？",
    join_as_mediator_popup_description: "您确定要以参与者身份加入通话吗？单击下方的确认，然后在下一个屏幕中单击连接以作为参与者（调解员）加入。",
    guest_lable: "客人",
    overall_experience: "总体体验？",
    leave_comment: "发表评论（可选）",
    sent: "发送",
    send: "发送",
    color_label: "颜色",
    view_unavailable: "查看不可用",
    thanks: "谢谢！",
    whisper_label: "耳语",
    stop_recording_tooltip_label: "返回画廊模式以停止录制。",
    save_image: "保存图片",
    screenshare_mweb_text: "从您的设备共享屏幕需要一个应用程序。请从移动应用程序连接此会话。",
    disconnect_and_launchapp_btn: "断开连接并启动应用程序",
    device_battery_low: "设备电池电量低",
    notes_lable: "笔记",
    new_note_lable: "新笔记",
    only_visible_to_you: "只对你可见",
    empty_note: "空纸条",
    title_lable: "标题",
    delete_lable: "删除",
    delete_Note: "删除笔记",
    want_delete_this_note: "你确定要删除这条笔记么？",
    failed_delete_note: "无法删除备注。",
    note_deleted_successfully: "笔记已删除",
    failed_edit_note: "无法编辑备注。",
    note_edited_successfully: "笔记已更新",
    failed_add_note: "添加备注失败。",
    note_added_successfully: "已添加备注",
    batteryinfo_tooltip: "设备电池信息",
    screenshare_mweb_title: "需要下载应用程序",
    screenshare_mweb_desc1: "从您的设备共享屏幕需要一个应用程序。",
    screenshare_mweb_desc2: "下载应用程序。",
    upcoming_event: "即将发生的事件",
    scheduled_to_start_in: "计划开始于",
    please_wait_for_the_host_to_start_this_event: "请等待主持人开始此活动，然后重试。",
    image_deleted: "图片已删除",
    failed_to_delete_image: "删除图片失败",
    are_you_sure_you_want_to_delete_image: "您确定要永久删除此图片吗？",
    delete_image_title: "删除图片",
    sms_sent_label: "短信已发送！",
    whatsapp_sent_label: "WhatsApp 邀请已发送！",
    whatsapp_label: "微信",
    email_sent_label: "邮件已发送！",
    smartglass_sent_label: "Smartglass 邀请已发送！",
    schedule_to_start_in_a_few_seconds: "计划在几秒钟内启动。",
    location_image_thumb_caption: "位置图片",
    updated_successfully: "更新成功",
    edit_label: "编辑",
    scan_code_lable: "扫码",
    scan_code_result: "扫码结果",
    extract_text_result: "提取文本结果",
    scan_code_result_not_found: "无法从图像扫描二维码/条形码。请使用清晰的图像重试。",
    host_features_will_not_be_available_when_using_app: "使用 App 时将无法使用主机功能",
    note_colon: "笔记：",
    leave_lable: "离开",
    are_you_sure_you_want_to_leave_this_call: "您确定要退出此通话吗？",
    supported_browser_versions: "支持的浏览器版本",
    see: "看",
    call_disconnected: "呼叫断开",
    video_quality: "视频质量",
    low_bandwidth: "低带宽",
    adaptive: "自适应",
    high_quality: "高质量",
    wait_for_the_call_to_start: "等待呼叫开始",
    enter_email_send: "输入电子邮件以发送邀请",
    send_invitaion_lable: "发送邀请",
    enter_mobile_number_lable: "输入手机号码",
    enter_valid_mobile: "输入有效的手机号码。",
    dont_show_this_again: "不再显示此内容",
    share_invitation_with_others: "与他人分享会议邀请",
    new_email_address: "电子邮件地址",
    invite_participant_lable: "邀请参与者",
    saved_label: "已保存！",
    show_stream: "展示",
    hide_stream: "隐藏",
    has_sent_you_link_for_video_conference: "<company_name>已向您发送了实时视频会议的链接。",
    copy_invitation: "复制会话邀请",
    copy_invitation_desc: "复制预定时间的邀请文本并手动发送",
    copied: "已复制！",
    copy_session_code: "复制会话 ID",
    copy_link_to_share: "复制链接以共享",
    session_invitation_copied: "会话邀请已复制到剪贴板。",
    observer_url_copied: "观察者 URL 已复制到剪贴板。",
    invite_sent_successfully: "邀请发送成功",
    sms_label: "短信",
    copy: "复制",
    enter_valid_email: "输入有效的电子邮件地址。",
    limit_exceeded: "超出限制",
    other: "其他",
    join_the_session: "加入会议",
    camera_permission_required_title: "需要相机许可",
    camera_permission_required_disc1: "要分享实时视频，请在浏览器设置中打开相机权限，然后",
    reload_page_disc: "重新加载页面。",
    location_permission_required_title: "需要位置许可",
    microphone_permission_required_title: "需要麦克风权限",
    confirmation_lable: "我可以确认我已阅读并同意",
    live_location: "实时位置",
    no_one_shared_location: "没有人分享他们的位置",
    it_was_great_lable: "太棒了",
    not_so_great_lable: "不太好",
    link_copied: "链接已复制",
    whats_new: "什么是新的",
    microphone_publication_description: "未找到麦克风或其他应用程序可能正在使用麦克风。",
    please_close_all_other_application: "请关闭所有其他可能正在使用麦克风的应用程序，然后重试。",
    app_to_share_your_device_screen: "在应用程序中继续此通话以共享您的设备屏幕",
    launch_app: "启动应用程序",
    screen_share_requires_app: "屏幕共享需要一个应用程序。",
    only_takes_few_seconds: "这只需几秒钟。",
    download_app_from_app_store_and_then_return_page: "从 App Store 下载应用程序，然后返回此页面。",
    click_to_download_app: "点击下载应用",
    go_to_Step_2: "如果您已经下载了应用程序，请转到步骤 2",
    next_lable: "下一个",
    rejoin_the_call_in_app: "在 App 中重新加入通话",
    step2_screen_share_description: "下载App后，您可以在App中重新加入本次通话，选择“屏幕共享”来共享您的手机屏幕。",
    disconnect_the_call_in_browser: "这将断开浏览器中的呼叫",
    back_btn_lable: "后退",
    rejoin_call_in_app: "在应用程序中重新加入通话",
    beta_release_tag_des1: "此功能目前处于 Beta 版。",
    email_support_feedback: "请发送电子邮件至 support@blitzz.co 分享您的反馈。",
    would_you_like_to_exit_markup: "您想退出标记吗？",
    live_captions: "实时字幕",
    starting_label: "开始...",
    live_captions_started: "实时字幕开始。",
    spoken_language_is_set_to_english: "口语设置为英语。",
    current_position: "当前位置",
    start_point: "起点",
    click_to_open_more_information: "点击打开更多信息",
    open_in_safari_chrome_or_install_mobile_app:
        "请将此链接复制并粘贴到最新版本的 Safari 或 Google Chrome 浏览器中或安装我们的移动应用程序，然后重试。",
    continue_without_name: "无名继续",
    enter_your_name: "输入你的名字",
    ignore: "忽视",
    screen_share_info: "为避免无限镜像，请勿共享整个屏幕或浏览器窗口。而是只共享一个选项卡或不同的窗口。",
    screen_share_to_everyone: "您正在与所有人共享屏幕",
    stop_share_screen: "停止共享屏幕",
    unable_to_start_the_video_please_download_the_app_to_continue: "无法启动视频，请下载应用程序以继续。",
    upload: "上传",
    from_device: "从设备",
    from_camera: "从相机",
    upload_failed_files: "上传失败的文件",
    uploaded_max_file: "您已上传允许的最大文件数。",
    upload_files: "上传文件",
    upload_limit_reached: "已达到上传限制",
    drop_for_upload_or_select: "放在这里上传，或选择",
    upload_20_file: "一次最多上传 20 个文件。",
    max_size_20MB: "最大限度。文件大小<fileSize> MB。",
    cancel_upload: "取消上传",
    cancel_upload_alert: "取消上传？",
    file_details_deleted: "添加到文件中的任何详细信息都将被删除。",
    uploaded_files: "上传的文件",
    capture_image: "捕获图像",
    participant_uploading_file_msg: "其他参与者正在上传文件，请稍候。",
    previous: "以前的",
    max_file_count: "您一次最多可以上传<fileCount>个文件。",
    removed_more_than_20MB_file: "大小超过<fileSize> MB 的文件将被删除。",
    uploading_files: "上传文件",
    upload_failed_file_count: "上传失败： <numberOfFailedFiles>个文件未上传。",
    add_caption: "添加字幕...",
    uploaded_files_of_a_maximum: "已上传<successCount>文件，最多<totalCount>个",
    you_have_selected_the_maximum_number_of_files_allowed: "您已选择允许的最大文件数。",
    upload_max_count: "上传最大<remainingCount>文件。",
    image_upload_msg: "正在上传图片，请稍候",
    finished_uploading: "上传完毕",
    upload_files_msg: "上传文件",
    uploading_dots: "正在上传…",
    loading_image_counter: "正在加载<totalCount>的图像<counter> >",
    closing_tab: "关闭选项卡",
    close_tab: "关闭标签",
    return_to_home_screen: "返回主屏幕",
    session_code_expire_msg: "此链接已关闭",
    view_call_logs: "查看通话记录",
    measurements: "测量",
    copy_all: "全部复制",
    measure: "措施",
    view_supported_device: "查看支持的设备",
    device_not_support_google_play_service: "参与者设备不支持 3D 测量所需的 Google Play 服务",
    device_not_compatible_for_measurement: "设备不兼容测量",
    device_required_update_google_play_service: "参与者设备需要更新 Google Play 服务才能启动 3D 测量。",
    device_required_google_play_service: "参与者设备需要安装 Google Play 服务才能启动 3D 测量",
    app_required_update_for_measurement: "支持测量所需的应用程序更新",
    app_required_for_measurement: "测量所需的配套应用程序",
    preparing_ar_measurement: "正在准备测量视图...",
    measurement_copied_msg: "测量值复制到剪贴板",
    ready_for_measurement: "准备测量",
    move_device_to_start: "移动设备开始",
    tacking_not_available: "跟踪不可用",
    camera_use_bu_another_app: "相机正在被另一个应用程序使用",
    more_light_required: "需要更多的光",
    move_further_away: "走得更远",
    slow_down: "减速",
    measurement_cancelled: "测量已取消",
    app_required: "此功能需要下载应用程序。 <learnmore>",
    learn_more: "学到更多",
    ar_measurement_description_step2: "下载App后，您可以在App中重新加入本次通话，选择“测量”开始AR测量",
    ar_measurement_description_step1: "增强现实测量功能允许您测量 3D 对象，需要下载应用程序",
    app_to_support_ar_measurement: "在 App 中继续此调用以支持 AR 测量",
    find_surface_to_measure: "查找附近的表面进行测量",
    measurement_toast_note_to_guide_user: "注意：测量值是近似值。",
    measurement_toast_msg_to_guide_user: "为获得最佳效果，请在距离手机 0.5 到 3 米（2 到 10 英尺）的明确对象上使用“测量”。",
    having_audio_issue: "有音频问题？",
    remote_participant_voice_not_coming_description: "看起来您目前难以听到其他参与者的声音或遇到某种音频问题。",
    workaround_action_for_remote_audio_not_coming: "<click_here>应用快速解决方法。",
    click_here_for_audio_label: "点击这里",
    measurement_copyall_msg: "测量值已复制到剪贴板",
    armarkup_cancelled: "AR 标记已取消",
    device_not_support_google_play_service_for_markup: "参与者设备不支持 3D 标记所需的 Google Play 服务",
    device_required_update_google_play_service_for_markup: "参与者设备需要更新 Google Play 服务才能启动 3D 标记。",
    device_required_google_play_service_for_markup: "参与者设备需要安装 Google Play 服务才能启动 3D 标记",
    device_not_compatible_for_AR_Markup: "设备不兼容 AR 标记",
    app_required_update_for_AR_Markup: "支持 AR Markup 所需的 App 更新",
    app_required_for_AR_Markup: "支持 AR 标记所需的应用程序",
    preparing_view_for_ar_markup: "正在为 AR 标记准备视图...",
    AR_Markup_Lable: "增强现实标记",
    armarkup_toast_msg_to_guide_user: "为获得最佳效果，请在距离手机 0.5 至 3 米（2 至 10 英尺）的明确定义的对象上使用标记。",
    ar_live_streaming_ready_to_markup: "AR 实时流式传输准备好标记。",
    ar_markups_cleared_for_all_users: "为所有用户清除 AR 标记。",
    ar_live_streaming_marking_stopped: "AR 直播标记已停止",
    agent_has_ended_ar_markup_cannot_continue_without_agent: "代理已结束 AR 标记。没有代理无法继续 AR 标记",
    ar_markup_cancelled: "AR 标记已取消",
    ready_for_ar_markup: "准备好 AR 标记",
    max_ar_arrow_limit_toast_message: "已达到箭头限制，请使用全部清除来添加更多。",
    video_paused: "视频暂停",
    discard_label: "丢弃",
    discard_image_label: "丢弃图像",
    save_image_label: "保存图片",
    go_room_call_limit_reached: "Go room 已达到呼叫限制",
    circle: "圆圈",
    arrow_with_text: "带有文字的箭头",
    add_shadow_and_stroke: "添加阴影和描边",
    font_label: "字体：",
    file_type_not_supported: "不支持的文件类型",
    crt_acnt_enter_confirm_password: "",
    create_new_note_description: "请点击下面的“新建笔记”按钮开始记笔记",
    remote_user_stream_interrupted: "远程用户流中断",
    audio_disabled_by_admin: "管理员已禁用音频",
    audio_disabled: "音频已禁用",
    dont_show_again: "不再显示",
    having_an_issue_with_joining_the_call: "加入通话时遇到问题？",
    to_perform_network_check: "进行网络检查",
    you_were_removed_from_the_call_by_the_host: "主持人已将您从通话中移除",
    you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now: "您已被主持人移除出通话，现在无法重新加入。",
    host_removed_you_from_the_call: "主持人已将您移除出通话。",
    unable_to_join_the_call: "无法加入通话",
    host_muted_your_microphone: "主持人已将您的麦克风静音。",
    unmute_your_microphone: "取消麦克风静音",
    host_invites_you_to_speak_unmute_your_microphone_when_ready: "主持人邀请您发言。准备好后请取消麦克风静音。",
    got_it: "知道了",
    unmute_mic: "取消麦克风静音",
    host_turned_off_your_camera: "主持人关闭了你的摄像头。",
    turn_your_camera_on: "打开相机",
    host_invites_you_to_turn_your_camera_on: "主持人邀请您打开相机。",
    turn_camera_on: "开启相机",
    start_sharing_your_screen: "开始共享您的屏幕",
    host_invites_you_to_share_your_screen: "主持人邀请您共享您的屏幕。",
    share_screen: "共享屏幕",
    remove_all: "全部删除",
    remove: "消除",
    end_call: "结束通话",
    removing_all_participants_will_end_the_call: "删除所有参与者将结束通话。",
    are_you_sure_you_want_to_remove_from_this_call: "您确定要从本次通话中删除<participantName>吗？",
    block_from_rejoining_this_call: "阻止<participantName>重新加入此通话",
    turn_all_mics_off: "关闭所有麦克风",
    turn_all_cams_off: "关闭所有摄像头",
    ask_to_turn_mic_on: "请求打开麦克风",
    turn_mic_off: "关闭麦克风",
    turn_cam_off: "关闭摄像头",
    ask_to_turn_cam_on: "请求打开摄像头",
    ask_to_share_screen: "请求共享屏幕",
    having_a_video_problem: "遇到了视频问题？",
    ios_play_pause_modal_body_text: "尝试禁用手机的省电模式来解决此问题，或者请单击下面的播放按钮立即播放视频。",
    play_video: "播放视频",
    camera_request_sent: "相机请求已发送。",
    waiting_for_host_approval: "等待主人批准。",
    microphone_request_sent: "麦克风请求已发送。",
    camera_request_denied: "相机请求被拒绝。",
    click_the_camera_icon_if_you_need_to_request_again: "如果需要再次请求，请单击相机图标。",
    microphone_request_denied: "麦克风请求被拒绝。",
    click_the_mic_icon_if_you_need_to_request_again: "如果需要再次请求，请单击麦克风图标。",
    deny: "否定",
    allow: "允许",
    user_wants_to_start_their_camera: "<ParticipantName>想要启动他们的<micOrCam>",
    error_in_processing_live_caption_please_retry: "处理实时字幕时出错，请重试。",
    virtual_background: "虚拟背景",
    upload_image: "上传图片",
    remove_image: "移除图像",
    remove_background_image: "删除背景图像",
    are_you_sure_you_want_to_remove_background_image: "您确定要删除背景图像吗？",
    unsupported_file_format: "不支持的文件格式。",
    the_maximum_file_size_supported_is_in_mb: "支持的最大文件大小为<size> MB。",
    no_effect: "无效果",
    blur_background: "模糊背景",
    default_image: "默认图像",
    virtual_background_not_supported: "不支持虚拟背景。",
    remove_from_call: "从通话中删除",
    enable_offline_mode: "启用离线模式",
    offline_mode_enabled: "离线模式已启用",
    your_images_will_upload_when_you_reconnect: "当您重新连接时，您的图像将会上传。",
    please_keep_this_screen_open: "请保持此屏幕打开。",
    max_images_upload: "最多<count>图片",
    remaining_image_count_label: "<remainingCount>张图片，共<totalCount>张图片",
    selected_images: "精选图片",
    offline_uploads_are_not_supported_in_private_mode: "私人模式不支持离线上传。",
    please_switch_to_a_normal_browser_tab_to_use_this_feature: "请切换到普通浏览器选项卡以使用此功能。",
    guest_is_using_a_private_browser_window: "访客正在使用私人浏览器窗口。",
    offline_upload_mode_is_not_supported_in_this_case: "在这种情况下不支持离线上传模式。",
    some_images_failed_to_upload_due_to_a_network_error: "由于网络错误，某些图像上传失败。",
    closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode: "关闭此模式将丢弃您在离线模式下选择的所有图像。",
    live_captions_stopped: "实时字幕已停止。",
    translate: "翻译",
    auto_translate: "自动翻译",
    your_language: "您的语言",
    translation_info_text: "其他参与者的消息将自动翻译成您选择的语言。",
    translating: "正在翻译……",
    show_original: "显示原文",
    show_translation: "显示翻译",
    translated: "翻译",
    send_message_in: "发送消息",
    audio_translation: "翻译",
    audio_translation_setup: "音频翻译",
    they_speak: "对方语言",
    i_want_to_hear: "我想听",
    start_translation: "开始翻译",
    stop_translation: "停止翻译",
    starting_translation: "正在启动翻译...",
    translation_started: "音频翻译已启动。",
    translation_stopped: "音频翻译已停止。",
    translation_error: "翻译错误。请重试。",
    translation_active: "翻译中",
    voice_type: "语音",
    voice_female: "女声",
    voice_male: "男声",
};

export default zh;
